import React, { useState } from 'react';

import { NavLinkButton, Button, ButtonGroup, Modal } from '@shared/components/bootstrap';

import { newAccountPickupURL, newAccountReturnURL, newAccountTaskOrderURL } from '@admin/config/routes';
import { client } from '@admin/libraries/apollo';
import { Account__State, useAccountPageButtonsQuery } from '@admin/schema';

export const NewOrderButtons: React.FC<{ accountID: string }> = ({ accountID }) => {
  const [showAlert, setShowAlert] = useState<boolean>(false);

  const { data } = useAccountPageButtonsQuery({ client, variables: { accountID } });
  const account = data?.account;

  const pickupText = account?.onboardable ? 'New Onboarding' : 'New Pickup';
  const accountHasLoggedIn = account && account.signInCount > 0;
  const permissions = account?.permissions;
  const canBookOrders = permissions?.bookOrders;
  const canOverride = permissions?.overrideBookOrders;

  return (
    <>
      <ButtonGroup>
        {permissions?.bookWarehouseReturn && account?.state === Account__State.Suspended && (
          <NavLinkButton kind="danger" to={newAccountReturnURL({ accountID, warehouseReturn: true })}>
            New Auction
          </NavLinkButton>
        )}
        {permissions?.bookMaintenancePickup && (
          <NavLinkButton kind="danger" to={newAccountPickupURL({ accountID, external: false })}>
            New Maintenance Pickup
          </NavLinkButton>
        )}
        {canBookOrders && (
          <>
            {canOverride && (
              <NavLinkButton kind="primary" to={newAccountTaskOrderURL({ accountID })}>
                New Task Order
              </NavLinkButton>
            )}
            {accountHasLoggedIn || canOverride ? (
              <NavLinkButton kind="primary" to={newAccountReturnURL({ accountID })}>
                New Return
              </NavLinkButton>
            ) : (
              <Button kind="primary" onClick={() => setShowAlert(true)}>
                New Return
              </Button>
            )}
            {accountHasLoggedIn || canOverride || account?.onboardable ? (
              <NavLinkButton kind="primary" to={newAccountPickupURL({ accountID })}>
                {pickupText}
              </NavLinkButton>
            ) : (
              <Button kind="primary" onClick={() => setShowAlert(true)}>
                {pickupText}
              </Button>
            )}
          </>
        )}
      </ButtonGroup>
      {showAlert && (
        <Modal onClose={() => setShowAlert(false)}>
          <Modal.Content>
            <Modal.Header>
              <Modal.Title>Unable to Create New Order</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              This customer has not activated their online account and agreed to Clutter’s Terms of Service. This must
              be done before booking any new appointments. Please direct the customer here to set up their online
              account: https://account.clutter.com/activate.
            </Modal.Body>
            <Modal.Footer>
              <Button kind="default" onClick={() => setShowAlert(false)}>
                Close
              </Button>
            </Modal.Footer>
          </Modal.Content>
        </Modal>
      )}
    </>
  );
};
